import "./BotProfileCard.css";
import ConfigSection from "../ConfigSection/ConfigSection";
import IconButton from "/src/components/UI/Button/IconButton/IconButton";
import exportBotProfilPdf from "../../services/exportBotProfilPdf";

function BotProfileCard({ bot, companyName }) {
    return (
        <div className="bot-profile-card">
            <div className="bot-profile-card-header">
                <i className="fas fa-robot"></i>
                <span className="bot-profile-card-name">{bot.name}</span>
                <IconButton
                    onClick={() => exportBotProfilPdf(companyName, [bot])}
                    className="bot-profile-card-export"
                    icon="fas fa-file-pdf"
                    title="Export this bot as PDF"
                ></IconButton>
            </div>
            <hr className="bot-profile-divider" />
            <ConfigSection icon="fa-brain" label="AI Model" accentColor="#0e7aed" items={bot.ai.map((a) => ({ primary: a.provider, secondary: a.model, block: a.block }))}/>
            <ConfigSection icon="fa-volume-up" label="Text-to-Speech" accentColor="#06A77D" items={bot.tts.map((t) => ({ primary: t.vendor, secondary: t.model, block: t.block }))}/>
            <ConfigSection icon="fa-microphone" label="Speech-to-Text" accentColor="#fd7723" items={bot.stt.map((s) => ({ primary: s.vendor, secondary: s.model, block: s.block }))}/>
            <ConfigSection icon="fa-plug" label="External APIs" accentColor="#9d20ec"
                items={bot.externalApis.map((a) => ({
                    primary: a.host,
                    secondary: `${a.blocks.length} block${a.blocks.length > 1 ? "s" : ""}`,
                    blocks: a.blocks,
                }))}
            />
        </div>
    );
}

export default BotProfileCard;
